import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, forwardRef } from '@angular/core';
import { ElioHasPermissionModule } from '@elio/emanager-front/shared/directives';
import { AbstractFilterOption, AndFilterOption, OrFilterOption } from '@elio/emanager-front/shared/models';
import { ElioButtonComponent } from '@elio/emanager-front/shared/ui/button';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { TranslocoModule } from '@ngneat/transloco';
import { LetDirective, PushPipe } from '@ngrx/component';
import { TooltipModule } from 'primeng/tooltip';
import { FilterableType } from '../../filter.token';
import { ElioFilterAccordionComponent } from '../filter-accordion/filter-accordion.component';
import { ElioFilterItemComponent } from '../filter-item/filter-item.component';

@Component({
  selector: 'elio-filters-list[filter]',
  templateUrl: './filters-list.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ElioButtonComponent,
    ElioFilterAccordionComponent,
    forwardRef(() => ElioFilterItemComponent),
    ElioHasPermissionModule,
    ElioSvgIconsModule,
    LetDirective,
    PushPipe,
    TooltipModule,
    TranslocoModule,
  ],
  host: {
    class: 'flex flex-col flex-grow overflow-hidden',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElioFiltersListComponent<T extends FilterableType> {
  @Input() filter!: AndFilterOption<T> | OrFilterOption<T>;

  trackById(_index: number, item: AbstractFilterOption<T>) {
    return item.id;
  }
}
